import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchACMs, fetchACMsByAgent, deleteACM } from '../../../Redux/Actions/actions';
import style from './ACMList.module.css';

const ACMList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(state => state.user);
  const { acms, acmsPagination, acmLoading } = useSelector(state => state);
  const [page, setPage] = useState(1);
  const [filterTipo, setFilterTipo] = useState('');

  const isAdmin = user?.user?.type === 'admin';

  useEffect(() => {
    const params = { page, limit: 10 };
    if (filterTipo) params.tipoInmueble = filterTipo;

    if (isAdmin) {
      dispatch(fetchACMs(params));
    } else if (user?.user?.id) {
      dispatch(fetchACMsByAgent(user.user.id, params));
    }
  }, [dispatch, page, filterTipo, isAdmin, user?.user?.id]);

  const handleDelete = async (id) => {
    if (!window.confirm('¿Estás seguro de eliminar este ACM?')) return;
    try {
      await dispatch(deleteACM(id));
    } catch (e) {
      alert('Error al eliminar: ' + (e.message || 'Error desconocido'));
    }
  };

  return (
    <div className={style.container}>
      <div className={style.header}>
        <h2>Mis ACMs</h2>
        <button className={style.newButton} onClick={() => navigate('/acm')}>
          + Nuevo ACM
        </button>
      </div>

      <div className={style.filters}>
        <select
          value={filterTipo}
          onChange={(e) => { setFilterTipo(e.target.value); setPage(1); }}
          className={style.filterSelect}
        >
          <option value="">Todos los tipos</option>
          {['casa', 'departamento', 'terreno', 'ph', 'local', 'oficina', 'galpon',
            'cochera', 'deposito', 'campo', 'hotel', 'fondo de comercio',
            'nave industrial', 'edificio', 'emprendimiento', 'duplex', 'triplex',
            'cabaña', 'quinta', 'otro'].map(t => (
            <option key={t} value={t}>{t.charAt(0).toUpperCase() + t.slice(1)}</option>
          ))}
        </select>
      </div>

      {acmLoading && <p className={style.loading}>Cargando...</p>}

      {!acmLoading && acms.length === 0 && (
        <p className={style.empty}>No hay ACMs registrados.</p>
      )}

      <div className={style.list}>
        {acms.map((acm) => (
          <div key={acm.id} className={style.card}>
            <div className={style.cardInfo}>
              <h3>{acm.propietario || 'Sin propietario'}</h3>
              <p className={style.ubicacion}>{acm.ubicacion}</p>
              <div className={style.tags}>
                <span className={style.tag}>{acm.tipoInmueble || 'N/A'}</span>
                {acm.version && <span className={style.tagVersion}>v{acm.version}</span>}
              </div>
              {acm.valorACM && (
                <p className={style.valor}>U$D {Number(acm.valorACM).toLocaleString('es-ES')}</p>
              )}
              <p className={style.fecha}>
                {acm.createdAt ? new Date(acm.createdAt).toLocaleDateString('es-ES') : ''}
              </p>
            </div>
            <div className={style.cardActions}>
              <button className={style.btnEdit} onClick={() => navigate(`/acm-editar/${acm.id}`)}>
                Editar
              </button>
              <button className={style.btnDetail} onClick={() => navigate(`/acm-detalle/${acm.id}`)}>
                Detalle
              </button>
              <button className={style.btnDelete} onClick={() => handleDelete(acm.id)}>
                Eliminar
              </button>
            </div>
          </div>
        ))}
      </div>

      {acmsPagination && (
        <div className={style.pagination}>
          <button
            disabled={page <= 1}
            onClick={() => setPage(p => p - 1)}
            className={style.pageBtn}
          >
            ← Anterior
          </button>
          <span className={style.pageInfo}>
            Página {page} {acmsPagination.totalPages ? `de ${acmsPagination.totalPages}` : ''}
          </span>
          <button
            disabled={!acmsPagination.totalPages || page >= acmsPagination.totalPages}
            onClick={() => setPage(p => p + 1)}
            className={style.pageBtn}
          >
            Siguiente →
          </button>
        </div>
      )}
    </div>
  );
};

export default ACMList;
